module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/buy-prize_1-95d777d1156ef81ecaae93254115ae83.png";